<template>
    <main class="withdraw-limit">
        <div :infinite-scroll-disabled="true">
          <img :src="youpPath+item" v-for="(item,index) in imgUrls" :key="index"/>
        </div>
    </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
export default {
  data () {
    return {
      youpPath: IMG_BASE_URL,
      imgUrls: [
        '/upaiyun/Sys/20190221/5727855012619415156.jpg'
      ]
    }
  }
}
</script>

<style scoped="scoped">
  .withdraw-limit,.withdraw-limit img{
    width:100%;
  }
</style>
